import { createMuiTheme } from '@material-ui/core/styles';
import { colors } from '../Constants/constants';

export const theme = createMuiTheme({
	palette: {
		primary: {
			// light: will be calculated from palette.primary.main,
			main: '#32A3F5',
			// dark: will be calculated from palette.primary.main,
			// contrastText: will be calculated to contrast with palette.primary.main
		},
		secondary: {
			main: '#FFFFFF',
		},
	},
	overrides: {
		MuiTab: {
			root: {
				textTransform: 'none',
			},
		},
		MuiToolbar: {
			regular: {
				padding: '30px',
			},
		},
		MuiAppBar: {
			colorPrimary: {
				backgroundColor: '#E5E5E5',
			},
		},
		MuiFormHelperText: {
			root: {
				position: 'relative',
			},
		},
		MuiCheckbox: {
			colorSecondary: {
				color: colors.main,
				'&$checked': {
					color: colors.main,
				},
			},
		},
		MuiRadio: {
			colorPrimary: {
				color: colors.main,
				'&$checked': {
					color: colors.main,
				},
			},
		},
		MuiButton: {
			colorPrimary: {
				color: colors.main,
				'&$primary': {
					color: colors.default,
				},
				label: {
					color: '#ffffff',
				},
			},
		},
		MuiSelect: {
			icon: {
				fill: colors.main,
			},
		},
		MuiPickersToolbar: {
			toolbar: {
				backgroundColor: colors.main,
			},
		},
		MuiPickersCalendarHeader: {
			switchHeader: {
				// backgroundColor: lightBlue.A200,
				// color: "white",
			},
		},
		MuiPickersDay: {
			day: {
				color: colors.main,
			},
			daySelected: {
				backgroundColor: colors.main,
			},
			dayDisabled: {
				color: 'rgba(0, 0, 0, 0.38)',
			},
			current: {
				color: colors.main,
			},
		},
		MuiPickersModal: {
			dialogAction: {
				color: colors.main,
			},
		},
		MuiPaper: {
			elevation1: {
				boxShadow: false,
			},
		},
		MuiStepIcon: {
			root: {
				'&$completed': {
					color: colors.main,
				},
				'&$active': {
					color: colors.main,
				},
			},
		},
	},
});
